import WidgetCustomizationPanel from '../../../components/WidgetCustomizationPanel';
import { useBotWorkspace } from '../../../hooks/useBotWorkspace';
import { widgetURL, API_BASE } from '../../../utils/botHelpers';

export default function EmbedRoute() {
  const { bot } = useBotWorkspace();
  if (!bot) return null;

  const snippet = `<script src="${widgetURL}/widget.js" data-bot-id="${bot.id}"${API_BASE ? ` data-api-url="${API_BASE}"` : ''}></script>`;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div style={{ background: 'var(--bg-card)', borderRadius: '12px', border: '1px solid var(--card-border)', padding: '24px' }}>
        <div style={{ color: 'var(--text-secondary)', fontSize: '14px', fontWeight: '600', marginBottom: '20px' }}>Embed your chat widget</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <div style={{ color: 'var(--text-muted)', fontSize: '12px' }}>Paste before {'</body>'} on your site</div>
          <button onClick={() => { navigator.clipboard.writeText(snippet); alert('Copied!'); }}
            style={{ background: '#5B4FE8', border: 'none', color: 'white', padding: '6px 16px', borderRadius: '7px', fontSize: '12px', cursor: 'pointer' }}>Copy code</button>
        </div>
        <div style={{ background: 'var(--bg-page)', borderRadius: '8px', padding: '16px', border: '1px solid var(--card-border)', marginBottom: '24px' }}>
          <code style={{ color: '#818cf8', fontSize: '13px', wordBreak: 'break-all' }}>{snippet}</code>
        </div>
        {[
          { n: '1', title: 'Copy the code', desc: 'Click "Copy code" above.' },
          { n: '2', title: 'Open your website editor', desc: 'Works on WordPress, Wix, Squarespace, or plain HTML.' },
          { n: '3', title: 'Paste before </body>', desc: 'Find the closing </body> tag in your theme footer and paste just before it.' },
          { n: '4', title: 'Publish and test', desc: 'Save and publish. The chat bubble appears bottom-right.' },
        ].map(s => (
          <div key={s.n} style={{ display: 'flex', gap: '14px', marginBottom: '16px', alignItems: 'flex-start' }}>
            <div style={{ width: '26px', height: '26px', borderRadius: '50%', background: '#5B4FE8', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '700', flexShrink: 0 }}>{s.n}</div>
            <div>
              <div style={{ color: 'var(--text-primary)', fontSize: '13px', fontWeight: '600', marginBottom: '2px' }}>{s.title}</div>
              <div style={{ color: 'var(--text-faint)', fontSize: '12px' }}>{s.desc}</div>
            </div>
          </div>
        ))}
      </div>
      <WidgetCustomizationPanel botId={bot.id} initialConfig={(bot as any).widgetConfig} />
    </div>
  );
}
